import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement } from './endpoints';
import axiosBaseQueryUserMangement from './axiosBaseQueryUserMangement';

export const enumApi = createApi({
  reducerPath: 'enumApi',
  baseQuery: axiosBaseQueryUserMangement({ baseUrl: process.env.REACT_APP_USER_MANAGEMENT_BASE_URL }),
  tagTypes: ['enum'],
  endpoints: (builder) => ({
    getEnumData: builder.mutation({
      query(body) {
        return {
          url: userManagement.enumController.getEnumData,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: {
            enumTypes: [
              'MERCHANT_TYPE',
              'OFFER_TYPE',
              'DISCOUNT_TYPE',
              'TIER_TYPE',
              'OFFER_FOR',
              // 'AMENITIES_TYPE',
              'COMPANY_TYPE',
              'PARKING_CATEGORY',
              // 'CANCELLATION_REASON',
              'PARKING_CATEGORY_TYPE',
              'PARKING_TYPE',
              'LABOUR_DOCUMENTS',
              'VEHICLE_AMENITIES_TYPE',
              'BOOKING_TYPE',
              'PERMIT_TYPE',
              'VEHICLE_TYPE',
              'VEHICLE_FUEL_TYPE',
              'VEHICLE_GEAR_TYPE',
              "PACKAGE_TYPE",
              "MAP_KEY",
              "ACCOUNT_TYPE", 
              "BUSINESS_TYPE",
            ],
          },
        };
      },
    }),
  }),
});

export const { useGetEnumDataMutation } = enumApi;
